import { defineMessages } from "react-intl";

export const cancelOrderDialogMessages = defineMessages({
  dialogTitle: {
    id: "wmeRVH",
    defaultMessage: "Cancel order #{orderNumber}",
    description: "dialog header",
  },
  dialogContent: {
    id: "NWA+MK",
    defaultMessage:
      "<b>Important:</b> Refunds need to be issued <b>manually</b> after order cancelation.",
    description: "dialog content",
  },
  buttonKeepOrder: {
    id: "p6ugX0",
    defaultMessage: "Keep order",
    description: "button to keep order",
  },
  buttonCancelOrder: {
    id: "bKTEnb",
    defaultMessage: "Cancel order",
    description: "button to cancel order",
  },
  reasonLabel: {
    id: "zU+7Up",
    defaultMessage: "Cancellation reason",
    description: "cancel order, reason select label",
  },
  reasonMissingPayment: {
    id: "AQjoLh",
    defaultMessage: "Missing or failed payment",
    description: "cancel order reason",
  },
  reasonOutOfStock: {
    id: "ndnN7T",
    defaultMessage: "Out of stock",
    description: "cancel order reason",
  },
  reasonCustomerRequest: {
    id: "GQVPi1",
    defaultMessage: "Customer request",
    description: "cancel order reason",
  },
  reasonDuplicate: {
    id: "oc0TDJ",
    defaultMessage: "Duplicate order",
    description: "cancel order reason",
  },
  reasonFraud: {
    id: "9ghf6H",
    defaultMessage: "Suspected fraud",
    description: "cancel order reason",
  },
  reasonOther: {
    id: "R5e30T",
    defaultMessage: "Other (specify)",
    description: "cancel order reason, freehand option",
  },
  reasonOtherLabel: {
    id: "8O2MCh",
    defaultMessage: "Describe the reason",
    description: "cancel order, freehand reason input label",
  },
  notifyCustomerLabel: {
    id: "pCJxuh",
    defaultMessage: "Send cancellation email to the customer",
    description: "cancel order, notify customer checkbox",
  },
  notifyReasonLabel: {
    id: "vKzDji",
    defaultMessage: "Include reason in the cancellation email sent to the customer",
    description: "cancel order, notify customer with reason checkbox",
  },
});
